import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router';
import AppHeader from '../components/AppHeader';
import TrianualActionButton from '../components/TrianualActionButton';
import AppPageLayout from '../layout/AppPageLayout';

function EvaluacionesTrianualesPage() {
  const navigate = useNavigate();

  const goToListado = () => {
    navigate('/evaluaciones-trianuales/listado');
  };

  return (
    <AppPageLayout>
      <AppHeader />

      <div className="mx-auto mt-10 w-full max-w-[560px] lg:mt-12 lg:max-w-[760px]">
        <h1 className="text-center font-login text-[30px] font-bold leading-tight text-[#30343b] sm:text-[36px]">
          Evaluaciones Operativas
          <span className="block">Trianuales</span>
        </h1>

        <div className="mt-8 border-t border-[#eceff3] pt-6">
          <button
            type="button"
            onClick={() => navigate('/dashboard')}
            className="inline-flex h-10 w-10 items-center justify-center rounded-full text-[#111111] transition hover:bg-[#f5f7fa]"
            aria-label="Volver al dashboard"
          >
            <ArrowLeft className="h-5 w-5" strokeWidth={2.8} />
          </button>

          <div className="mt-5 space-y-4 sm:space-y-5">
            <TrianualActionButton onClick={goToListado}>
              Nuevas Evaluaciones Trianuales
            </TrianualActionButton>

            <TrianualActionButton tone="secondary" onClick={goToListado}>
              Evaluaciones Asignadas
            </TrianualActionButton>
          </div>
        </div>

        <div className="pt-10 text-center font-login text-[10px] text-[#5f6673]">
          <p>Copyright 2022 JPH Lions Todos los derechos reservados</p>
        </div>
      </div>
    </AppPageLayout>
  );
}

export default EvaluacionesTrianualesPage;
